import './assets/base/_base.scss';

import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import routes from './router/routes';
import type { Theme } from './themes';
import { themes, themeSelector } from './themes';

momentDurationFormatSetup(moment);

// Old -> New theme mapping
const themeMapping: Record<string, string> = {
  'light-theme': 'light-theme-viewnexa',
  'dark-theme': 'dark-theme-viewnexa',
};

let localStorageTheme = localStorage.getItem('app-theme');
let theme: Theme | undefined;

if (localStorageTheme && themeMapping[localStorageTheme]) {
  localStorageTheme = themeMapping[localStorageTheme];
  // Optionally update storage so it doesn't break in future
  localStorage.setItem('app-theme', localStorageTheme);
}

if (localStorageTheme) {
  theme = themes.find((t) => t.name === localStorageTheme);
}
if (!theme) {
  theme = themes[0];
}
themeSelector.setTheme(theme.name);

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<RouterProvider router={routes} />);
